import React from "react";
import { DownOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Menu, message, Spin } from "antd";
import { connect } from "dva";
import { router } from "umi";
import { logout } from "@/utils/session";
import HeaderDropdown from "@/components/HeaderDropdown";
import SignedLinkWrapper from "@/components/SignedLinkWrapper";
import styles from "./index.less";

const AvatarDropdown = ({ currentProfile, configPerm }) => {
  const onMenuClick = async event => {
    const { key } = event;

    if (key === "logout") {
      const hide = message.loading("Signing out...");

      const logoutResponse = await logout(currentProfile?.email);

      if ("error" in logoutResponse) {
        hide();
        message.error("An error occurred while signing out");
        return;
      }

      hide();
      router.replace("/user/login");

      return;
    }

    if (key === "settings") {
      const urlParams = new URLSearchParams(window.location.search);
      const entityId = urlParams.get("entityId");
      router.push(entityId ? `/settings?entityId=${entityId}` : "/settings");
      return;
    }

    router.push(`/account/${key}`);
  };

  const menuHeaderDropdown = (
    <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
      {(configPerm["IdentityService.Profiles"] || configPerm["CoreService.Companies"]) && (
        <Menu.Item key="settings">
          <SettingOutlined />
          Your Account
        </Menu.Item>
      )}
      <Menu.Item key="logout">
        <LogoutOutlined />
        Sign out
      </Menu.Item>
    </Menu>
  );

  return currentProfile && currentProfile.firstName ? (
    <HeaderDropdown overlay={menuHeaderDropdown}>
      <span className={`${styles.action} ${styles.account}`}>
        <Avatar
          className={styles.avatar}
          style={{ background: "#f2f2f2", color: "#000" }}
          alt="avatar"
          icon={
            currentProfile.profilePhoto ? (
              <SignedLinkWrapper privateUrl={currentProfile.profilePhoto}>
                {signedUrl => <img src={signedUrl} style={{ width: 32 }} />}
              </SignedLinkWrapper>
            ) : (
              <UserOutlined />
            )
          }
        />
        <span className={styles.name}>{currentProfile?.fullName}</span>
        <DownOutlined style={{ marginLeft: 5, marginTop: 2 }} />
      </span>
    </HeaderDropdown>
  ) : (
    <Spin
      size="small"
      style={{
        marginLeft: 8,
        marginRight: 8,
      }}
    />
  );
};

export default connect(({ configs, user }) => {
  return {
    currentProfile: user.currentProfile,
    configPerm: configs.configPerm,
  };
})(AvatarDropdown);
